module.exports = __webpack_public_path__ + "img/mono_13.a72334a3.png";